import { Component } from '@angular/core';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../services/http/wordpress/wordpress.interface';
import { CommonModule } from '@angular/common';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';

@Component({
  selector: 'app-cookies-page',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './cookies-page.component.html',
  styleUrl: './cookies-page.component.scss'
})
export class CookiesPageComponent {
  title = "";
  description = "";
  image = "";

  cookiesText = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({ client: WpClientCode.genCat, section: WpSectionCode.cookies }).subscribe((data) => {
      if (data) {
        this.cookiesText = data.content.rendered;
        this.title = data.title.rendered;
        this.image = data.acf.image_url;
      }
    });
  }
}
